import {createStore} from "vuex";
import cart from "@/store/module/cart";
import router from "@/router";
import {getActiveLanguages, getUser, login, postFCMToken} from "@/API/API";
//import { getUser, login } from "@/API/API";
import httpClient from "@/API/HttpClient";
import fcmToken from "@/utils/fcm";
import i18n from "@/locale/i18n";

export default createStore({
    state: {
        token: localStorage.getItem("token") || "",
        user: localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user"))
            : {},
        roomNumber: "",
        languages: [],
        locale: localStorage.getItem("locale") ?? 'fa',
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem("token", state.token);
        },
        SET_USER(state, user) {
            state.user = user;
            localStorage.setItem("user", JSON.stringify(state.user));
        },
        SET_ROOM_NUMBER(state, roomNumber) {
            // state.roomNumber = roomNumber
            localStorage.setItem("roomNumber", roomNumber);
        },
        LOGOUT(state) {
            state.token = "";
            state.user = {};
            localStorage.removeItem("token");
            localStorage.removeItem("user");
        },
        SET_LANGUAGES(state, languages) {
            state.languages = languages
        },
        SET_LOCALE(state, locale) {
            state.locale = locale
            localStorage.setItem('locale', state.locale)
        }
    },
    actions: {
        login({commit}, {phone, password}) {
            return new Promise((resolve, reject) => {
                login(phone, password)
                    .then((resp) => {
                        httpClient.defaults.headers.common["Authorization"] =
                            "Bearer " + resp.data.token;
                        commit("SET_TOKEN", resp.data.token);
                        getUser().then((user) => commit("SET_USER", user));
                        // fcmToken().then(token => postFCMToken(token))
                        fcmToken()
                            .then((token) => postFCMToken(token))
                            .catch(console.log("خطاردرfirebase"));
                        resolve();
                    })
                    .catch((err) => {
                        reject(err.response.data);
                    });
            });
        },
        setUser({commit}, user) {
            commit("SET_USER", user);
        },
        setRoomNumber({commit}, roomNumber) {
            commit("SET_ROOM_NUMBER", roomNumber);
        },
        logout({commit}) {
            commit("LOGOUT");
            router.push("/login");
        },
        async getLanguages({commit}) {
            let languages = (await getActiveLanguages()).data
            commit('SET_LANGUAGES', languages)
        },
        setLocale({commit}, locale) {
            commit('SET_LOCALE', locale)
            httpClient.defaults.headers.common['X-Locale'] = locale
            i18n.global.locale = locale
        }
    },
    modules: {
        cart,
    },
    getters: {
        token: (state) => "Bearer " + state.token,
        isLoggedIn: (state) => state.token !== "",
    },
});
